import { PlayerEvent } from '../PlayerEvent';
import { useModal, usePermissions } from '/src/hooks';
import { ErrorDetailsModal } from '../modals/ErrorDetailsModal';
import { ErrorsUpsellModal } from '/src/features/errors/components/modals/ErrorsUpsellModal';
import { FEATURES } from '/src/features/_global/constants';

import { ReactComponent as ErrorIcon } from '@crazyegginc/hatch/dist/images/icon-warning-filled.svg';

export function ErrorEvent({ timestamp, active, fingerprint, errorId, siteId, onClick, ...rest }) {
  const modal = useModal();
  const permissions = usePermissions();
  const { allowed: canViewDashboard } = permissions.can('view', FEATURES.ERRORS_TRACKING);

  return (
    <PlayerEvent
      icon={ErrorIcon}
      title="Error"
      text={fingerprint}
      timestamp={timestamp}
      active={active}
      isErrorEvent={true}
      onClick={() => {
        onClick?.();
        if (!canViewDashboard) {
          modal.show(<ErrorsUpsellModal />);
        } else {
          modal.show(<ErrorDetailsModal errorId={errorId} siteId={siteId} />);
        }
      }}
      {...rest}
    />
  );
}
